const ruInt = new Intl.NumberFormat('ru-RU');
const usd2 = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const usd4 = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
});

export const formatInt = (n: number): string => ruInt.format(n);

export const formatUsd = (n: number): string => (n < 1 ? usd4.format(n) : usd2.format(n));

export const formatPct = (n: number, digits = 1): string => `${n.toFixed(digits)}%`;

export function formatDurationMs(ms: number | null): string {
  if (ms === null) return '—';
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}с`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}м`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}ч ${m % 60}м`;
  const d = Math.floor(h / 24);
  return `${d}д ${h % 24}ч`;
}

const dateShort = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: 'short' });
const hourShort = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit' });

export const formatDayLabel = (iso: string): string => dateShort.format(new Date(iso));
export const formatHourLabel = (iso: string): string => hourShort.format(new Date(iso));
